import { Component } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ApiservicesService } from 'src/app/services/apiservices.service';

@Component({
  selector: 'app-account-settings',
  templateUrl: './account-settings.component.html',
  styleUrls: ['./account-settings.component.css']
})
export class AccountSettingsComponent {



  public stateList: any = [];

 

  // emailregex: RegExp = /^(([^<>()\[\]\\.,;:\s@']+(\.[^<>()\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  emailregex: RegExp = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
  passwordregex: RegExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;
  public isedit: boolean = false;
  public addFormLoader: boolean = false;
  public formdata: any = {};
  public formfieldrefresh: any = null;
  public formfieldrefreshdata: any = null;
  public cookieData: any
  public editFormData: any
  statusarr: any = [{ val: 1, name: 'Active' }, { val: 0, name: 'Inactive' }];

  constructor(private activateRoute: ActivatedRoute, private apiservice: ApiservicesService, private _snackBar: MatSnackBar, private router: Router, public matSnackBar: MatSnackBar, public cookieService: CookieService) {
    this.getStates();
    
  }
 
  getStates() {
    this.apiservice.getHttpData("../../../../../assets/data-set/state.json").subscribe(response => {
      console.log(response, "this.stateList")
      // this.stateList = response;
      if (response && response.length > 0) {
        response.forEach((e:any, i:number) => {
          let obj = { val: e.abbreviation, name: e.name };
          this.stateList.push(obj)
        })
      }
      console.log('resolveval', this.stateList)
    })
  }

  ngOnInit() {
    if (this.cookieService.getAll()['login_user_details']) {
      this.cookieData = JSON.parse(this.cookieService.getAll()['login_user_details']);
    }
    if (this.activateRoute.snapshot.params && this.activateRoute.snapshot.params["_id"]) {
      this.activateRoute.data.subscribe((response: any) => {
        console.log("edit data", response)
        if (response) {
          if (response.data.results.res) {
            this.isedit = true;
            this.editFormData = response.data.results.res[0];
          }
        }
      });
      // this.editForm();
    }
    this.initailForm();

  }

  initailForm() {
    this.formdata =
    {
      // from start
      successmessage: 'Added Successfully !!', // success message
      submittext: this.editFormData ? 'Update' : 'Submit',
      apiUrl: this.apiservice.baseUrl,
      // endpoint: 'email/addtemplate',
      redirectpath: "user-management/user-list",
      resettext: 'Reset',
      canceltext: 'Back',
      hidereset: this.editFormData ? true : false,
      jwttoken: '',
      groups: ["grp0", "grp1", "grp2", "grp3", "grp4", "grp5", "grp6", "grp7"],
      cancelroute: `user-management/user-list`, // use for redirect after cancel the form
      fields: [



        {
          label: 'First Name',
          name: 'firstname',
          group: "grp0",
          value: this.editFormData && Object.keys(this.editFormData).length > 0 ? this.editFormData.firstname : '',
          type: 'text',
          validations: [
            { rule: 'required', message: 'First Name is Required' },

          ],
        },
        {
          label: 'Last Name',
          name: 'lastname',
          group: "grp0",
          value: this.editFormData && Object.keys(this.editFormData).length > 0 ? this.editFormData.lastname : '',
          type: 'text',
          validations: [
            { rule: 'required', message: 'Last Name is Required' },

          ],
        },



        {
          label: 'Email',
          name: 'email',
          type: 'email',
          disabled: this.editFormData ? true : false,
          group: "grp0",
          hint: '',
          value: this.editFormData && Object.keys(this.editFormData).length > 0 ? this.editFormData.email : '',
          validations: [
            { rule: 'required', message: 'Email is required' },
            {
              rule: 'pattern',
              value: this.emailregex,
              message: 'Must be a valid Email',
            },
          ],
        },

        {
          label: 'Phone',
          name: 'phone',
          value: this.editFormData && Object.keys(this.editFormData).length > 0 ? this.editFormData.phone : '',
          formatflag: true,
          type: 'numberformat',
          // type: 'number',
          group: "grp0",
          validations: [{ rule: 'required', message: 'Phone is Required' }],
        },

        {
          label: 'Fax',
          name: 'fax',
          value: this.editFormData && this.editFormData.fax ? this.editFormData.fax : '',
          formatflag: true,
          type: 'numberformat',
          group: "grp0",
          // type: 'number',
          validations: [{ rule: 'required', message: 'Fax is Required' }],
        },

        {

          label: 'Gender',
          name: 'gender',
          type: 'select',
          group: "grp0",
          hint: '',
          val: [{ val: 'male', name: 'Male' }, { val: 'female', name: 'Female' }],
          multiple: false,
          value: this.editFormData && this.editFormData.gender ? this.editFormData.gender : '',
          validations: [
            { rule: 'required', message: 'Gender is required' },
          ]
        },
        {
          label: 'Address',
          name: 'address',
          value: this.editFormData && this.editFormData.address ? this.editFormData.address : '',
          group: "grp1",
          type: 'textarea',
          validations: [
            { rule: 'required', message: 'Address is Required' },

          ],
        },
        {
          label: 'State',
          name: 'state',
          value: this.editFormData && this.editFormData.state ? this.editFormData.state : '',
          group: "grp2",
          val: this.stateList,
          type: 'select',
          validations: [
            { rule: 'required', message: 'State is Required' },

          ],
        },

        {
          label: 'City',
          name: 'city',
          value: this.editFormData && this.editFormData.city ? this.editFormData.city : '',
          group: "grp2",
          type: 'text',
          validations: [
            { rule: 'required', message: 'City is Required' },

          ],
        },
        {
          label: 'Zip',
          name: 'zip',
          value: this.editFormData && this.editFormData.zip ? this.editFormData.zip : '',
          group: "grp2",
          type: 'text',
          validations: [
            { rule: 'required', message: 'Zip is Required' },

          ],
        },

        {
          label: 'Password',
          name: 'password',
          passwordflag: true,
          group: "grp3",
          value: '',
          type: this.editFormData ? 'hidden' : 'password',
          validations: [
            { rule: 'required', message: 'Password is Required' },
            { rule: 'pattern', value: this.passwordregex, message: "Must contain a Capital Letter and a Number" }
          ],
        },
        {
          label: 'Confirm Password',
          name: 'confirmpassword',
          passwordflag: true,
          group: "grp3",
          value: '',
          type: this.editFormData ? 'hidden' : 'password',
          validations: [{ rule: 'required', message: 'Confirm Password is Required' }],
        },

        {
          label: 'User Type',
          name: 'user_type',
          value: "admin",
          type: 'hidden'
        },



        {

          label: 'Active',
          name: 'status',
          type: 'checkbox',
          hint: '',
          val: this.statusarr,
          value: this.editFormData && this.editFormData.status ? this.editFormData.status : '',

        }

      ]

    }
  }




  listenFormFieldChange(val: any) {
    console.log("dataobj", val)
    if (val.field && val.field == "fromsubmit") {
      let dataobj = {
        data: val.fromval
      }
      if (this.editFormData) {
        dataobj.data._id = this.editFormData._id
      }

      this.addFormLoader = true;
      console.log("dataobj------------", dataobj);

      this.apiservice.httpViaPost('email/addtemplate++++', dataobj).subscribe((response) => {
        console.log("response", response);

        if (response) {
          if (response.status == 'success') {

            this.addFormLoader = false;
            this.matSnackBar.open(this.editFormData ? "Updated Successfully" : response.message, "Ok", {
              duration: 2000
            });
            // this.router.navigateByUrl(`${this.cookieData.user_type}/user-management/user-list`);
            this.router.navigateByUrl(`user-management/user-list`);
          }
          else {
            this.matSnackBar.open(response.message, "", {
              duration: 2000
            });
            this.addFormLoader = false;
          }
        }

      })

    }
  }

  isActive = false;

  toggleActive() {
    this.isActive = !this.isActive;
  }
}
